<template>
  <div><NewCoursesComponent></NewCoursesComponent></div>
</template>

<script>
import NewCoursesComponent from "../../components/Courses/newcourse.component.vue";
export default {
  components: {
    NewCoursesComponent,
  },
};
</script>

<style></style>
